import React, { useEffect, useState } from 'react'
import { Select, DatePicker } from 'antd'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'

import { GrFormClose } from 'react-icons/gr'

import Header from '../components/Header'
import Loader from '../components/Loader'
import { getAllTransactions } from '../redux/actions/transactionAction'
import { getAllTeamsList } from '../redux/actions/teamActions'
import PlayerDetailsModal from '../components/modal/PlayerDetailsModal'
import { openModal } from '../redux/actions/interfaceModalActions'

const AllTransaction = () => {
  const { RangePicker } = DatePicker
  const [transaction, setTransaction] = useState([])
  const [teamsList, setTeamsList] = useState([])
  const [selectedTeam, setSelectedTeam] = useState(null)
  const [dateRange, setDateRange] = useState(null)
  const [loading, setLoading] = useState(true)

  const dispatch = useDispatch()

  const getData = async () => {
    setLoading(true)
    const payload = {
      team: selectedTeam,
      dateRange,
    }
    const data = await getAllTransactions(payload)
    setTransaction(data)
    setLoading(false)
  }
  useEffect(() => {
    getData()
  }, [selectedTeam, dateRange])

  const getTeams = async () => {
    let teams = await getAllTeamsList()
    setTeamsList(teams)
  }
  useEffect(() => {
    getTeams()
  }, [])

  const onChangeTeamFilter = async (e) => setSelectedTeam(e)

  const rangeChangeHandler = async (e, v) => {
    if (v[0]?.length > 0 && v[1]?.length > 0) {
      setDateRange(v)
    } else {
      setDateRange(null)
    }
  }

  const SM = {
    movedToNonActive: 'moved to non-active',
    movedToActiveRoster: 'player has been moved to active roster',
    movedAuctionWaiver: 'player moved to auction, due to waiver exempt',
    movedProtectedList: 'moved to protected list',
    movedFromProtectedList: 'moved from protected list',
    playerTraded: 'player traded',
    released: 'released',
    movedIr: 'moved to injured reserve',
    movedLTIR: 'moved to lt injured reserve',
    auction: 'auction',
    approvedDraft: 'player approved from draft',
  }

  return (
    <>
      <Header />

      <div
        style={{
          margin: '1rem 0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '1rem',
        }}
      >
        <Select
          placeholder='Select Team'
          onChange={onChangeTeamFilter}
          allowClear={{ clearIcon: <GrFormClose size={25} onClick={() => {}} /> }}
          onClear={async () => {
            setSelectedTeam(null)
          }}
          options={teamsList?.map((item) => ({
            value: item?._id,
            label: item?.name,
          }))}
          className='filter_select_box'
          style={{ minWidth: '180px' }}
        />

        <RangePicker className='all_transaction_picker' onChange={rangeChangeHandler} />
      </div>

      <div className='transaction_tracker_box transaction_height_box'>
        <section className='transaction_tracker_body'>
          {loading ? (
            <Loader />
          ) : (
            <>
              {transaction?.length > 0 ? (
                transaction?.map((item, i) => {
                  const module = item?.module?.toLowerCase()
                  const subModule = item?.sub_module?.toLowerCase()
                  return (
                    <div key={i} className='card_box'>
                      <div>
                        <span className='text1'>Franchise:</span> &nbsp;
                        <span className='text2'>{item?.team?.name}</span>
                      </div>
                      <div>
                        <span className='text1'>Type:</span> &nbsp;
                        <span className='text2'>{item?.module}</span>
                      </div>
                      <div>
                        <span className='text1'>Date:</span> &nbsp;
                        <span className='text2'>
                          {moment(item?.createdAt).format('ddd MMM D h:mm:ss a. [ET] YYYY')}
                        </span>
                      </div>
                      <div>
                        <span className='text1'>Transaction::</span> &nbsp;
                        {module === 'squad' && subModule === SM.movedToNonActive && (
                          <span className='text2'>
                            Players move to non-active squad :{' '}
                            {item?.player?.map((v, index) => (
                              <>
                                <span
                                  key={index}
                                  style={{ color: 'var(--primary)' }}
                                  onClick={() => {
                                    dispatch(
                                      openModal({
                                        playerID: v?.PlayerID,
                                        isReserve: v?.isReserve ? true : false,
                                        teamId: null,
                                        teamName: '',
                                        teamLogo: null,
                                        isTransaction: {
                                          status: true,
                                        },
                                      }),
                                    )
                                  }}
                                >
                                  {v?.player_id?.Name}
                                </span>{' '}
                                ,
                              </>
                            ))}
                          </span>
                        )}
                        {module === 'squad' && subModule === SM.movedToActiveRoster && (
                          <span className='text2'>
                            {item?.sub_module}:{' '}
                            {item?.player?.map((v, index) => (
                              <>
                                <span
                                  key={index}
                                  style={{ color: 'var(--primary)' }}
                                  onClick={() => {
                                    dispatch(
                                      openModal({
                                        playerID: v?.PlayerID,
                                        isReserve: v?.isReserve ? true : false,
                                        teamId: null,
                                        teamName: '',
                                        teamLogo: null,
                                        isTransaction: {
                                          status: true,
                                        },
                                      }),
                                    )
                                  }}
                                >
                                  {v?.player_id?.Name}
                                </span>{' '}
                                ,
                              </>
                            ))}
                          </span>
                        )}
                        {module === 'waiver' && subModule === SM.movedAuctionWaiver && (
                          <span className='text2'>
                            {item?.sub_module}:{' '}
                            {item?.player?.map((v, index) => (
                              <>
                                <span
                                  key={index}
                                  style={{ color: 'var(--primary)' }}
                                  onClick={() => {
                                    dispatch(
                                      openModal({
                                        playerID: v?.PlayerID,
                                        isReserve: v?.isReserve ? true : false,
                                        teamId: null,
                                        teamName: '',
                                        teamLogo: null,
                                        isTransaction: {
                                          status: true,
                                        },
                                      }),
                                    )
                                  }}
                                >
                                  {v?.player_id?.Name}
                                </span>{' '}
                                ,
                              </>
                            ))}
                          </span>
                        )}
                        {module === 'squad' &&
                          (subModule === SM.movedProtectedList ||
                            subModule === SM.movedFromProtectedList) && (
                            <span className='text2'>
                              {item?.player?.map((v, index) => {
                                if (v?.status === 'from') {
                                  return (
                                    <>
                                      <span
                                        key={index}
                                        style={{ color: 'var(--primary)' }}
                                        onClick={() => {
                                          dispatch(
                                            openModal({
                                              playerID: v?.PlayerID,
                                              isReserve: v?.isReserve ? true : false,
                                              teamId: null,
                                              teamName: '',
                                              teamLogo: null,
                                              isTransaction: {
                                                status: true,
                                              },
                                            }),
                                          )
                                        }}
                                      >
                                        {v?.player_id?.Name}
                                      </span>{' '}
                                      ,
                                    </>
                                  )
                                }
                              })}
                              {` Moved to Active Squad `}
                              {item?.player?.map((v, index) => {
                                if (v?.status === 'to') {
                                  return (
                                    <>
                                      and{' '}
                                      <>
                                        <span
                                          key={index}
                                          style={{ color: 'var(--primary)' }}
                                          onClick={() => {
                                            dispatch(
                                              openModal({
                                                playerID: v?.PlayerID,
                                                isReserve: v?.isReserve ? true : false,
                                                teamId: null,
                                                teamName: '',
                                                teamLogo: null,
                                                isTransaction: {
                                                  status: true,
                                                },
                                              }),
                                            )
                                          }}
                                        >
                                          {v?.player_id?.Name}
                                        </span>{' '}
                                        ,
                                      </>
                                      Moved to Protected List
                                    </>
                                  )
                                }
                              })}
                            </span>
                          )}
                        {module === 'trade' && subModule === SM.playerTraded && (
                          <span className='text2'>
                            {item?.player?.map((v, index) => {
                              if (v?.status === 'buyer') {
                                return (
                                  <>
                                    <span
                                      key={index}
                                      style={{ color: 'var(--primary)' }}
                                      onClick={() => {
                                        dispatch(
                                          openModal({
                                            playerID: v?.PlayerID,
                                            isReserve: v?.isReserve ? true : false,
                                            teamId: null,
                                            teamName: '',
                                            teamLogo: null,
                                            isTransaction: {
                                              status: true,
                                            },
                                          }),
                                        )
                                      }}
                                    >
                                      {v?.player_id?.Name}
                                    </span>{' '}
                                    ,
                                  </>
                                )
                              }
                            })}
                            {` has been traded with `}
                            {item?.player?.map((v, index) => {
                              if (v?.status === 'seller') {
                                return (
                                  <>
                                    <>
                                      <span
                                        key={index}
                                        style={{ color: 'var(--primary)' }}
                                        onClick={() => {
                                          dispatch(
                                            openModal({
                                              playerID: v?.PlayerID,
                                              isReserve: v?.isReserve ? true : false,
                                              teamId: null,
                                              teamName: '',
                                              teamLogo: null,
                                              isTransaction: {
                                                status: true,
                                              },
                                            }),
                                          )
                                        }}
                                      >
                                        {v?.player_id?.Name}
                                      </span>
                                    </>
                                  </>
                                )
                              }
                            })}
                            {` from ${item?.sellerTradeTeam?.name}`}
                          </span>
                        )}
                        {module === 'squad' && subModule === SM.released && (
                          <span className='text2'>
                            Release from squad:{' '}
                            <span style={{ color: 'var(--primary)' }}>
                              {item?.player?.map((v, index) => (
                                <span
                                  key={index}
                                  style={{ color: 'var(--primary)' }}
                                  onClick={() => {
                                    dispatch(
                                      openModal({
                                        playerID: v?.PlayerID,
                                        isReserve: v?.isReserve ? true : false,
                                        teamId: null,
                                        teamName: '',
                                        teamLogo: null,
                                        isTransaction: {
                                          status: true,
                                        },
                                      }),
                                    )
                                  }}
                                >
                                  {v?.player_id?.Name}
                                </span>
                              ))}
                            </span>{' '}
                          </span>
                        )}
                        {module === 'squad' &&
                          (subModule === SM.movedIr || subModule === SM.movedLTIR) && (
                            <span className='text2'>
                              <span style={{ color: 'var(--primary)' }}>
                                {item?.player?.map((v, index) => (
                                  <span
                                    key={index}
                                    style={{ color: 'var(--primary)' }}
                                    onClick={() => {
                                      dispatch(
                                        openModal({
                                          playerID: v?.PlayerID,
                                          isReserve: v?.isReserve ? true : false,
                                          teamId: null,
                                          teamName: '',
                                          teamLogo: null,
                                          isTransaction: {
                                            status: true,
                                          },
                                        }),
                                      )
                                    }}
                                  >
                                    {v?.player_id?.Name}
                                  </span>
                                ))}
                              </span>{' '}
                              {item?.sub_module}
                            </span>
                          )}
                        {module === 'squad' && subModule === SM.auction && (
                          <span className='text2'>
                            <span style={{ color: 'var(--primary)' }}>
                              {item?.player?.map((v, index) => (
                                <>
                                  <span
                                    key={index}
                                    style={{ color: 'var(--primary)' }}
                                    onClick={() => {
                                      dispatch(
                                        openModal({
                                          playerID: v?.PlayerID,
                                          isReserve: v?.isReserve ? true : false,
                                          teamId: null,
                                          teamName: '',
                                          teamLogo: null,
                                          isTransaction: {
                                            status: true,
                                          },
                                        }),
                                      )
                                    }}
                                  >
                                    {v?.player_id?.Name}
                                  </span>{' '}
                                  ,
                                </>
                              ))}
                            </span>{' '}
                            moved to auction
                          </span>
                        )}
                        {module === 'squad' && subModule === SM.approvedDraft && (
                          <span className='text2'>
                            Approved from draft:{' '}
                            {item?.player?.map((v, index) => (
                              <span
                                key={index}
                                style={{ color: 'var(--primary)' }}
                                onClick={() => {
                                  dispatch(
                                    openModal({
                                      playerID: v?.PlayerID,
                                      isReserve: v?.isReserve ? true : false,
                                      teamId: null,
                                      teamName: '',
                                      teamLogo: null,
                                      isTransaction: {
                                        status: true,
                                      },
                                    }),
                                  )
                                }}
                              >
                                {v?.player_id?.Name}
                              </span>
                            ))}
                          </span>
                        )}
                      </div>
                    </div>
                  )
                })
              ) : (
                <p>No transaction found</p>
              )}
            </>
          )}
          <PlayerDetailsModal />
        </section>
      </div>
    </>
  )
}

export default AllTransaction
